/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
/* eslint-disable indent */
// Libraries
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { last, isEmpty, first } from 'lodash';
import {
    getId,
    getDependentSectionName,
    nameValueOptions,
} from '../../utils/helperMethods';
import { FormElems, Alert, AlertModal } from '../../components/';
import {
    fetchEntityHierarchyRequest,
    saveAndContinueRequest,
    setUniqueIdentifierRequest,
    fetchEntityListRequest,
    resetSaveDataSuccessKey,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    updateMerchantDataRequest,
    addMerchantStepUpdateMakerRequest,
    resetUpdateDataSuccessKey,
    getMerchantInfoRequest,
    setEntityDataRequest,
    setEntityDataSuccess,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import {
    ENTITY_TYPE,
    ENTITY_MAP,
    MAKER_CHECKER_EVENT_TYPES,
} from '../../utils/constants/commonValues';
import {
    fetchMerchantLegalEntityDetailsRequest,
    clearMerchantLegalEntityDetails,
} from '../../containers/MerchantLegalEntity/redux/merchantLegalEntity.actions';
import AddRole from './AddRole';
import validate from './validator';
import { stateCity, turnOverCategory, stateCode } from './constant';

import './merchantTab.scss';
import { BUSINESS_SECTION_TYPE_MLE } from '../Onboarding/Mle/BusinessTab/contants';
import { fetchPinCodeDetails, FIELD_TYPES } from '../Onboarding/Mle/mle.utils';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';
import { ERROR_FETCH } from '../Onboarding/Mle/mle.constants';

const getRollList = entityList => [
    {
        name: 'aggregator',
        popupTitle: 'Add Aggregator',
        props: {
            input: false,
            data: entityList.aggregator || [],
            label: 'Select Aggregator',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'AGGREGATOR',
    },
    {
        name: 'franchise',
        popupTitle: 'Add Franchise',
        props: {
            input: false,
            data: entityList.franchise || [],
            label: 'Select Franchise',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'FRANCHISE',
    },
    {
        name: 'mbe',
        popupTitle: 'Add MBE',
        props: {
            data: entityList.mbe || [],
            input: false,
            label: 'Select MBE',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'MBE',
    },
    {
        name: 'partner',
        popupTitle: 'Add Partner',
        props: {
            data: entityList.partner || [],
            input: false,
            label: 'Select Partner',
            labelField: 'name',
            valueField: 'entityCode',
            defaultSelected: '',
        },
        type: 'PARTNER',
    },
];

const MerchantTab = ({
    merchantData,
    handleSubmit,
    nextPath,
    previousPath,
    history,
    actions,
    sectionType,
    name,
    auth,
    initialValues,
    isEditMode,
    isViewMode,
    editData,
    draftData,
    formData,
    isInEditMode,
    change,
    staticData,
    onBoardSteps,
    merchantLegalEntityData,
    isDraft
}) => {
    const {
        entityList,
        saveData,
        timeline: { fields },
        hierarchyLoader,
        listExecuting,
        hierarchyData,
    } = merchantData;
    
    // eslint-disable-next-line react/prop-types
    const { editData: mleData } = merchantLegalEntityData;

    const { staticInfo } = staticData;

    const { updateData, entityValues } = editData;
    const { userDetails } = auth;
    const { userLevel } = userDetails;
    const { location } = history;
    const [categoryCodeList, setCategoryCodeList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [parentEntityCode, setParentEntityCode] = useState(null);
    const [roleList, setRoleList] = useState(getRollList(entityList));
    const [cityOptions, setCityOptions] = useState([]);
    const memoEntityValues = React.useMemo(() => {
        return {
            aggregator: entityValues.aggregator,
            franchise: entityValues.franchise,
            mle: entityValues.mle,
        };
    }, [entityValues.aggregator, entityValues.franchise, entityValues.mle]);
    const { aggregator, franchise, mle } = memoEntityValues;

    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );
    const [isChange, setIsChange] = useState(false);

    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';

    const [isShowModal, setIsShowModal] = useState(false);

    const [mleDetails, setMleDetails] = useState({});

    const onSuccessModal = () => {
        setIsShowModal(false);
        if (formData && formData.values) {
            handleFormSubmit(formData.values);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    // clear mle details and form of previous MID
    useEffect(() => {
        setMleDetails({});
        actions.change(
            'add-merchant-form',
            'mleId',
            null,
        );
    }, []);

    useEffect(() => {
        resetErrors();
        setRoleList(getRollList(entityList));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entityList]);

    useEffect(() => {
        fetchAllList();
        return () => {
            actions.setEntityDataSuccess({
                aggregator: '',
                franchise: '',
                mle: '',
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchAllList = () => {
        actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
        actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
        actions.fetchEntityListRequest(ENTITY_TYPE.MLE);
        actions.fetchEntityListRequest(ENTITY_TYPE.PARTNER);
    };

    useEffect(() => {
        if (!listExecuting && (aggregator || franchise || mle)) {
            handleRoleEdit(aggregator, franchise, mle);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, aggregator, franchise, listExecuting]);

    const handleRoleEdit = (aggregator, franchise) => {
        if (aggregator) {
            actions.fetchEntityHierarchyRequest(
                aggregator,
                'LOWER_COMPLETE',
                'AGGREGATOR',
                () => {
                    if (franchise) {
                        actions.fetchEntityHierarchyRequest(
                            franchise,
                            'LOWER_COMPLETE',
                            'FRANCHISE'
                        );
                    }
                }
            );
        }
    };

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    const onNext = () => {
        resetErrors();
        history.push(nextPath);
    };

    const onBack = () => {
        resetErrors();
        if (!isEditMode && !isViewMode && draftData && editData) {
            history.push('/mob/draft');
        } else {
            history.push(previousPath);
        }
    };

    useEffect(() => {
        if (
            draftData &&
            draftData.data &&
            draftData.data.parentEntityCode &&
            draftData.data.parentEntityType
        ) {
            const { parentEntityCode, parentEntityType } = draftData.data;
            actions.setEntityDataRequest(
                parentEntityCode,
                ENTITY_MAP[parentEntityType]
            );
        }
    }, [actions, draftData]);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.getMerchantInfoRequest(merchantId, fields, history, toast);
        }
    }, [actions, fields, history, isEditMode, isViewMode, location.pathname]);


    useEffect(() => {
        if (formData && formData.values) {
            handleSubCategorySelect(formData.values.merchantCategory, formData.values.subMerchantCategory);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.values.merchantCategory, formData.values.subMerchantCategory]);

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const handleFormSubmit = values => {
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            isChange &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const valuesCopy = values;
            valuesCopy.createdBy = userDetails.email || '';
            valuesCopy.updatedBy = userDetails.email || '';
            valuesCopy.userEmail = values.userEmail || '';
            valuesCopy.parentEntityCode =
                parentEntityCode === null
                    ? values.parentEntityCode
                    : parentEntityCode;
            valuesCopy.parentEntityCode =
                valuesCopy.parentEntityCode === ''
                    ? null
                    : valuesCopy.parentEntityCode;
            valuesCopy.stateCode = stateCode[values.state];
            const request = {
                uniqueIdentifier: `MID.${values.email}` || '',
                sectionType,
                data: valuesCopy,
            };

            if(!isEditMode){
                valuesCopy.mleId = hierarchyData.mle;
            }

            valuesCopy.aggregatorId = entitySelectedValue.aggregator;
            valuesCopy.partnerId = entitySelectedValue.partner;
            valuesCopy.franchiseId = entitySelectedValue.franchise;
            valuesCopy.mbeId = entitySelectedValue.mbe;

            actions.setUniqueIdentifierRequest(
                values.email || '',
                isInEditMode
            );
            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));

                const requestUpdate  = {
                    ...values,
                    entityCode: merchantId,
                    stateCode: stateCode[values.state],
                };
                requestUpdate.parentEntityCode =
                    parentEntityCode === null
                        ? values.parentEntityCode
                        : parentEntityCode;
                requestUpdate.parentEntityCode =
                    requestUpdate.parentEntityCode === ''
                        ? null
                        : requestUpdate.parentEntityCode;
                requestUpdate.userEmail = values.userEmail || '';
                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.MERCHANT,
                    isValidationRequired: true,
                };

                actions.addMerchantStepUpdateMakerRequest(
                    requestUpdate,
                    sectionType,
                    makerDetails
                );
            } else if (isViewMode) {
                onNext();
            } else {
                // Setting relationshipManagerId to current user of the user is a type of RM and is doing Onboarding
                if (userLevel === 'RM') {
                    request.data.relationshipManagerId =
                        userDetails.email || '';
                }
                actions.saveAndContinueRequest(request, sectionType);
            }
        }
    };
    const resetSelection = typeList => {
        const roles = roleList;
        roles.forEach(element => {
            if (typeList.includes(element.type)) {
                element.props.resetSelect = true;
            } else {
                element.props.resetSelect = false;
            }
        });
        setRoleList(roles);
    };
    const handleRoleSelect = (value, originalData, type) => {
        if (!value && !originalData && type === 'AGGREGATOR') {
            actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
            actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
            actions.fetchEntityListRequest(ENTITY_TYPE.MLE);
            resetSelection(['FRANCHISE', 'MLE']);
            setParentEntityCode('');
        }

        if (type === 'FRANCHISE') {
            resetSelection(['MLE']);
        } else if (type === 'AGGREGATOR') {
            resetSelection(['FRANCHISE', 'MLE']);
        }
        if (!value && !originalData && type === 'FRANCHISE') {
            if (editData.entityValues.aggregator) {
                actions.fetchEntityHierarchyRequest(
                    editData.entityValues.aggregator,
                    'LOWER_COMPLETE',
                    'AGGREGATOR'
                );
                setParentEntityCode(entitySelectedValue.aggregator);
            } else {
                actions.fetchEntityListRequest(ENTITY_TYPE.FRANCHISE);
                actions.fetchEntityListRequest(ENTITY_TYPE.MLE);
            }
        }

        if (!value && !originalData && type === 'MLE') {
            if (editData.entityValues.franchise) {
                setParentEntityCode(entitySelectedValue.franchise);
            }
        }
        if (originalData && originalData.entityCode && type === 'PARTNER') {
            setParentEntityCode(originalData.entityCode);
        }

        if (value && originalData && originalData.entityType !== 'MLE') {
            actions.fetchEntityHierarchyRequest(
                value,
                'LOWER_COMPLETE',
                originalData.entityType
            );
        }
        setIsChange(true);
    };

    const handleCategorySelect = value => {
        if (staticInfo && staticInfo.categoryMap && value) {
            const category = staticInfo.categoryMap.find(
                item => item.name.toLowerCase() === value.toLowerCase()
            );
            const options =
                category &&
                category.options.map(item => {
                    return { name: item.subCategory, value: item.subCategory };
                });
            setSubCategoryList(options);
        }else {
            setSubCategoryList([]);
        }
    };

    const handleSubCategorySelect = (value, subMerchantCategory) => {
        if (staticInfo && staticInfo.categoryMap && value && subMerchantCategory) {
            const category = staticInfo.categoryMap.find(
                item => item.name.toLowerCase() === value.toLowerCase()
            );

            const options =
                category &&
                category.options.map(item => {
                    return { name: item.subCategory, value: item.subCategory, mcc: item.mcc };
                }) || [];

            const subMerchantCategoryOptions = options.find(
                item => item.value.toLowerCase() === subMerchantCategory.toLowerCase()
            )?.mcc || [];

            const codeOptions = subMerchantCategoryOptions.map(item => {
                return { name: item, value: item };
            });

            setCategoryCodeList(codeOptions);
        }else {
            setCategoryCodeList([]);
        }
    };

    const [entitySelectedValue, setEntitySelectedValue] = useState(
        editData.entityValues
    );

    useEffect(() => {
        if(isViewMode || isEditMode) {
            setEntitySelectedValue({...entitySelectedValue, aggregator:editData?.entityValues?.aggregator, franchise:editData?.entityValues?.franchise,mle:editData?.entityValues?.mle});
        }
    }, [editData.entityValues]);

    useEffect(() => {
        if (initialValues.state) {
            const selectedStateCities = stateCity[initialValues.state];
            setCityOptions(nameValueOptions(selectedStateCities));
        }
    }, [initialValues, isEditMode]);

    const handleStateSelect = state => {
        if (!state) {
            actions.change('add-merchant-form', 'city', '');
            setCityOptions([]);
        } else {
            const selectedStateCities = stateCity[state];
            setCityOptions(nameValueOptions(selectedStateCities));
        }
    };
    useEffect(() => {
        if (formData && formData.values && formData.values.merchantCategory) {
            handleCategorySelect(formData.values.merchantCategory);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);
    
    useEffect(() => {
        if (formData && formData.values && formData.values.merchantCategory && formData.values.subMerchantCategory) {
            handleSubCategorySelect(formData.values.merchantCategory, formData.values.subMerchantCategory);
        }
    }, [formData]);

    const errorDetails = isEditMode ? updateData : saveData;

    const extractBusinessDetailAddress = mleData => {
        if (mleData && mleData.forms?.length > 0) {
            const mleDataValues = mleData.forms[0];
            if (mleDataValues && mleDataValues.sections.length > 0) {
                const sections = mleDataValues.sections;
                const businessDetailSection = sections.find(
                    item => item.type === 'businessDetailSection'
                );
                if (businessDetailSection) {
                    return { ...businessDetailSection.data.address,
                        legalName: businessDetailSection.data.legalName,
                        mobileNumber: businessDetailSection?.data?.mobileNumbers?.toString(),
                        email: businessDetailSection?.data?.emails?.toString(),
                    };
                }
            }
        }
        return null;
    };

    const capitalizeFirstChar = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const updateFormFields = (state, district) => {
        actions.change('add-merchant-form', 'state', capitalizeFirstChar(state));
        actions.change('add-merchant-form', 'district', capitalizeFirstChar(district));
    };

    const handlePincodeChange = async (pin) => {
        try {
            if (pin && pin.toString().length === 6) {
                const payload = {
                    sectionType: 'kycSection',
                    fieldType: 'pinCode',
                    fieldValue: pin
                };
                const response = await fetchPinCodeDetails(payload);
                const address = response.basicSectionData.pinCodeDetails;
                updateFormFields(address[0].stateName, address[0].districtName);
            } else {
                updateFormFields('', '');
            }
        } catch (e) {
            updateFormFields('', '');
        }
    };

    useEffect(() => {
        const address = extractBusinessDetailAddress(mleData);
        if (address) {
            setMleDetails(address);
        }
    }, [mleData]);

    useEffect(() => {
      // SET DEFAULT VALUES FOR ONLY FIRST TIME
        if (mleDetails && !isEditMode && !isViewMode && Object.keys(initialValues).length === 0) {
            handlePincodeChange(mleDetails.pinCode);
            actions.change('add-merchant-form', 'pinCode', mleDetails.pinCode);
            actions.change('add-merchant-form', 'addressLine1', mleDetails.addressLine);
        }
    }, [mleDetails, isEditMode, isViewMode]);

    useEffect(() => {
        // SET DEFAULT VALUES FOR ONLY FIRST TIME
        if (formData.initial && formData.initial.pinCode && isEditMode && isViewMode) {
            handlePincodeChange(formData.initial.pinCode);
        }

    }, [formData.initial, isEditMode, isViewMode]);


    useEffect(() => {
        const isMleDataEmpty = Object.keys(mleData || {}).length === 0;
    
        if (isMleDataEmpty) {
            if (hierarchyData.mle) {
                actions.fetchMerchantLegalEntityDetailsRequest({ entityCode: hierarchyData.mle });
            } else if (formData.values?.mleId) {
                actions.fetchMerchantLegalEntityDetailsRequest({ entityCode: formData.values.mleId });
            } else if (initialValues.mleId) {
                actions.fetchMerchantLegalEntityDetailsRequest({ entityCode: initialValues.mleId });
            }
        }
    
        if (!isEditMode && !isViewMode && !hierarchyData.mle && !isDraft) {
            history.push('/mob');
        }
    
        return () => {
            actions.clearMerchantLegalEntityDetails();
        };
    }, [
        actions,
        hierarchyData.mle,
        formData.values?.mleId,
        initialValues.mleId,
        isEditMode,
        isViewMode,
        history
    ]);

    useEffect(() => {
        if(hierarchyData && Object.keys(hierarchyData).length > 0) {
            setEntitySelectedValue({
                aggregator: hierarchyData.aggregator,
                franchise: hierarchyData.franchise,
                mbe: hierarchyData.mbe,
                // partner: hierarchyData.partner
            });
        }
    }, [hierarchyData]);

    useEffect(() => {
        if (!isEmpty(initialValues)) {
            setEntitySelectedValue({
                aggregator: initialValues.aggregatorId,
                franchise: initialValues.franchiseId,
                mbe: initialValues.mbeId,
                partner: initialValues.partnerId,
            });
        }
    }, [initialValues]);

    const handleTurnoverAmountRangeChange = (val) =>{
        if(val === staticInfo.merchantTurnover.small){
            actions.change(
                'add-merchant-form',
                'turnoverCategory',
                'Small',
            );
        }else if(val === staticInfo.merchantTurnover.large){
            actions.change(
                'add-merchant-form',
                'turnoverCategory',
                'Large',
            );
        }else {
            actions.change(
                'add-merchant-form',
                'turnoverCategory',
                '',
            );
        }
    }

    const handleTurnoverCategoryChange = (val) =>{
        if(val === 'Small'){
            actions.change(
                'add-merchant-form',
                'turnoverAmountRange',
                staticInfo.merchantTurnover.small,
            );
        }else if(val === 'Large'){
            actions.change(
                'add-merchant-form',
                'turnoverAmountRange',
                staticInfo.merchantTurnover.large,
            );
        }else {
            actions.change(
                'add-merchant-form',
                'turnoverAmountRange',
                '',
            );
        }
    }

    const validateEmail = (email) => {
        if (!email) return false;
        const regex = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        return regex.test(email);
    };


    const handleEmailBlur = () =>{
        const email = formData.values?.email;
        if(email && validateEmail(email)){
            actions.change(
                'add-merchant-form',
                'userEmail',
                email,
            );
            actions.change(
                'add-merchant-form',
                'pocEmail',
                email,
            );
        }
   }

    const handlePhoneNumberBlur = () =>{
        const mobileNumber = formData.values?.mobileNumber;
        if(mobileNumber){
            actions.change(
                'add-merchant-form',
                'pocPhoneNumber',
                mobileNumber,
            );
        }
    }

    return (
        <div className="merchant-tab">
            <form
                className="merchant-detail-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    onSuccessModal={onSuccessModal}
                    currentSection={currentStep}
                    message={`${getDependentSectionName(
                        onBoardSteps,
                        currentStep.dependentSections,
                    )}
                    ${isOrAre} dependent on ${currentStep.name}
                    section. Please update dependent sections.`}
                />
                <div className="merchant-details card merchant-boarding">
                    <h2 className="tab-title">Basic Details</h2>
                    <ul className="role-list">
                        {roleList.slice(0, 3).map(item => (
                            <AddRole
                                id={getId(item.name)}
                                hierarchyLoader={hierarchyLoader}
                                data={item}
                                entityValue={entitySelectedValue[item.name] || ''}
                                entitySelectedValue={entitySelectedValue}
                                setEntityValues={values =>
                                    setEntitySelectedValue(values)
                                }
                                onRoleSelect={handleRoleSelect}
                                isViewMode={isViewMode}
                                refreshValue={hierarchyData[item.name] || ''}
                            />
                        ))}
                    </ul>
                    <ul className="role-list">
                        {roleList.slice(3, 4)
                            .map(item => (
                                <AddRole
                                    id={getId(item.name)}
                                    hierarchyLoader={hierarchyLoader}
                                    data={item}
                                    entityValue={entitySelectedValue[item.name] || ''}
                                    entitySelectedValue={entitySelectedValue}
                                    setEntityValues={values =>
                                        setEntitySelectedValue(values)
                                    }
                                    onRoleSelect={handleRoleSelect}
                                    isViewMode={isViewMode}
                                    refreshValue={hierarchyData[item.name] || ''}
                                />
                            ))}
                        <li className={'form-section hidden'} />
                        <li className={'form-section hidden'} />
                    </ul>
                </div>
                <div className="merchant-details card merchant-boarding">
                    <h2 className="tab-title">MLE: {mleDetails.legalName}</h2>
                    {errorDetails.error && errorDetails.error.errorMessage ? (
                        <Alert customClass="error-msg">
                            {errorDetails.error.errorMessage}
                        </Alert>
                    ) : null}
                    <ul className="form-list">
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">DBA/Brand Name</p>
                                <Field
                                    name="name"
                                    type="text"
                                    id="merchant-name"
                                    component={FormElems.Input}
                                    placeholder="Enter DBA/Brand Name"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">Email</p>
                                <Field
                                    name="email"
                                    id="merchant-email-id"
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Email"
                                    disabled={isViewMode}
                                    handleBlur={handleEmailBlur}
                                />
                            </div>
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Mobile Number</p>
                                <Field
                                    name="mobileNumber"
                                    type="text"
                                    id="mobile-number"
                                    component={FormElems.Input}
                                    placeholder="Enter Mobile Number"
                                    disabled={isViewMode}
                                    handleBlur={handlePhoneNumberBlur}
                                />
                            </div>
                            <div className="form-field" />
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Turnover Category</p>
                                <Field
                                    name="turnoverCategory"
                                    placeholder="Turnover Category"
                                    id="turnover-category"
                                    data={
                                        nameValueOptions(turnOverCategory) || []
                                    }
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Select Turnover Category"
                                    disabled={isViewMode}
                                    onChange={handleTurnoverCategoryChange}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">Turnover Amount Range</p>
                                <Field
                                    name="turnoverAmountRange"
                                    placeholder="Turnover Amount Range"
                                    id="turnover-amount-range"
                                    data={[
                                        {
                                            name: staticInfo.merchantTurnover.small,
                                            value: staticInfo.merchantTurnover.small,
                                        },
                                        {
                                            name: staticInfo.merchantTurnover.large,
                                            value: staticInfo.merchantTurnover.large,
                                        },
                                    ]}
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Select Turnover Amount Range"
                                    disabled={isViewMode}
                                    onChange={handleTurnoverAmountRangeChange}
                                />
                            </div>
                        </li>

                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Pin Code</p>
                                <Field
                                    name="pinCode"
                                    type="number"
                                    id="pin-code"
                                    component={FormElems.Input}
                                    placeholder="Enter Pin Code"
                                    disabled={isViewMode}
                                    onChange={handlePincodeChange}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">State</p>
                                <Field
                                    name="state"
                                    placeholder="State"
                                    id="state"
                                    data={
                                        nameValueOptions(
                                            [formData.values && formData.values.state].filter(Boolean),
                                        ) || []
                                    }
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Select State"
                                    disabled={isViewMode || !formData.values.pinCode || (formData.values.pinCode && formData.values.pinCode.toString().length < 6)}
                                />
                            </div>
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">District</p>
                                <Field
                                    name="district"
                                    placeholder="District"
                                    id="district"
                                    data={
                                        nameValueOptions(
                                            [formData.values && formData.values.district].filter(Boolean),
                                        ) || []
                                    }
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Select District"
                                    disabled={isViewMode || !formData.values.pinCode || (formData.values.pinCode && formData.values.pinCode.toString().length < 6)}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">City</p>
                                <Field
                                    name="city"
                                    placeholder="Enter City"
                                    id="city"
                                    component={FormElems.Input}
                                    disabled={isViewMode || !formData.values.pinCode}
                                />
                            </div>
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Address</p>
                                <Field
                                    name="addressLine1"
                                    type="text"
                                    id="addressLine1"
                                    component={FormElems.TextArea}
                                    placeholder="Enter Address"
                                    disabled={isViewMode}
                                    maxLength={256}
                                />
                            </div>
                            <div className="form-field" />
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Merchant POC Name</p>
                                <Field
                                    name="pocName"
                                    id="merchant-poc-name"
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Merchant POC Name"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">
                                    Merchant POC Phone number
                                </p>
                                <Field
                                    name="pocPhoneNumber"
                                    id="merchant-poc-phone-number"
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Merchant POC Phone number"
                                    disabled={isViewMode}
                                />
                            </div>
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Merchant POC Email</p>
                                <Field
                                    name="pocEmail"
                                    id="merchant-poc-email"
                                    type="email"
                                    component={FormElems.Input}
                                    placeholder="Enter Merchant POC Email"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">
                                    Number Of Years In Business
                                </p>
                                <Field
                                    name="numberOfYearsInBusiness"
                                    id="number-of-years-in-business"
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="Enter Number Of Years In Business"
                                    disabled={isViewMode}
                                />
                            </div>
                        </li>

                        {userLevel !== 'RM' ? (
                            <li className="form-section">
                                <div className="form-field">
                                    <p className="label">
                                        Relationship Manager Name
                                    </p>
                                    <Field
                                        name="relationshipManagerId"
                                        placeholder="Enter Name"
                                        id="relationship-managerId"
                                        data={
                                            staticInfo.relationshipManagers ||
                                            []
                                        }
                                        labelField="name"
                                        valueField="value"
                                        component={FormElems.Select}
                                        label="Enter Name"
                                        disabled={
                                            isViewMode || userLevel === 'RM'
                                        }
                                    />
                                </div>
                                <div className="form-field">
                                    {(formData &&
                                        formData.values &&
                                        formData.values.turnoverAmount)  ? (
                                        <>
                                            <p className="label">
                                                Turnover Amount
                                            </p>
                                            <Field
                                                name="turnoverAmount"
                                                id="turnoverAmount"
                                                component={FormElems.Input}
                                                label="Turnover Amount"
                                                placeholder="Enter Turnover Amount"
                                                disabled={isViewMode}
                                            />
                                        </>
                                    ) : null}
                                </div>
                            </li>
                        ) : null}
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Merchant Category</p>
                                <Field
                                    name="merchantCategory"
                                    id="merchant-category"
                                    data={staticInfo.categoryMap || []}
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Enter Category"
                                    placeholder="Enter Category"
                                    onChange={() => {
                                        actions.change(
                                            'add-merchant-form',
                                            'subMerchantCategory',
                                            '',
                                        );
                                        actions.change(
                                            'add-merchant-form',
                                            'mcc',
                                            '',
                                        );
                                    setCategoryCodeList([]);
                                    }}
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field">
                                {(formData &&
                                    formData.values &&
                                    formData.values.merchantCategory) ||
                                (subCategoryList &&
                                    subCategoryList.length) ? (
                                    <>
                                        <p className="label">
                                            Sub Merchant Category
                                        </p>
                                        <Field
                                            name="subMerchantCategory"
                                            id="merchant-subMerchantCategory"
                                            data={subCategoryList || []}
                                            labelField="name"
                                            valueField="name"
                                            component={FormElems.Select}
                                            label="Sub Merchant Category"
                                            placeholder="Enter Code"
                                            disabled={isViewMode}
                                            onChange={() => {
                                                actions.change(
                                                    'add-merchant-form',
                                                    'mcc',
                                                    '',
                                                );
                                            }}
                                        />
                                    </>
                                ) : null}
                            </div>
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                {(formData &&
                                    formData.values &&
                                    formData.values.subMerchantCategory) ||
                                (categoryCodeList &&
                                    categoryCodeList.length) ? (
                                    <>
                                        <p className="label">
                                            Sub Merchant Category Code
                                        </p>
                                        <Field
                                            name="mcc"
                                            id="merchant-categoryCode"
                                            data={categoryCodeList || []}
                                            labelField="name"
                                            valueField="name"
                                            component={FormElems.Select}
                                            label="Enter Code"
                                            placeholder="Enter Code"
                                            disabled={isViewMode}
                                        />
                                    </>
                                ) : null}
                            </div>
                            <div className="form-field" />
                        </li>
                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Number Of Stores</p>
                                <Field
                                    name="noOfStores"
                                    placeholder="Enter Number Of Stores"
                                    id="number-of-stores"
                                    type='number'
                                    component={FormElems.Input}
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field" />
                        </li>

                        <li className="form-section">
                            <div className="form-field">
                                <p className="label">Portal User Email</p>
                                <Field
                                    name="userEmail"
                                    id="user-email"
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter User Email ID"
                                    disabled={ isViewMode }
                                />
                            </div>
                            <div className="form-field integration-type">
                                <p className="label">Merchant Type</p>
                                <Field
                                    name="integrationType"
                                    id="Radio-button"
                                    component={FormElems.Radio}
                                    labelField="name"
                                    disabled={
                                        isViewMode || isEditMode || isInEditMode
                                    }
                                    options={[
                                        {
                                            name: 'Online',
                                            value: 'Online',
                                            checked: false,
                                        },
                                        {
                                            name: 'Offline',
                                            value: 'Offline',
                                            checked: false,
                                        },
                                    ]}
                                    valueField="value"
                                />
                            </div>
                        </li>
                    </ul>
                </div>
                {/* <div className="form-section action">
                    {previousPath ? (
                        <FormElems.Button
                            id="back-btn"
                            buttonType="secondary"
                            text="BACK"
                            type="button"
                            handleClick={onBack}
                            customClass="back-btn"
                        />
                    ) : null}
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="NEXT"
                    />
                </div> */}
                <div className="form-section action">
                    {!isViewMode && (
                        <>
                            {previousPath && (
                                <FormElems.Button
                                    id="back-btn"
                                    buttonType="secondary"
                                    text="BACK"
                                    type="button"
                                    handleClick={onBack}
                                    customClass="back-btn"
                                />
                            )}
                            <FormElems.Button
                                id="next-btn"
                                buttonType="primary"
                                text="NEXT"
                            />
                        </>
                    )}
                </div>
            </form>
        </div>
    );
};

MerchantTab.propTypes = {
    actions: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
    draftData: PropTypes.object,
    staticData: PropTypes.object,
    isInEditMode: PropTypes.bool,
    onBoardSteps: PropTypes.array,
};

const mapStateToProps = ({
    auth,
    form,
    merchantData,
    editData,
    staticData,
    merchantLegalEntityData,
}) => ({
    auth,
    formData: form['add-merchant-form'],
    merchantData,
    editData,
    staticData,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchEntityHierarchyRequest,
            saveAndContinueRequest,
            setUniqueIdentifierRequest,
            resetSaveDataSuccessKey,
            updateMerchantDataRequest,
            addMerchantStepUpdateMakerRequest,
            fetchEntityListRequest,
            resetUpdateDataSuccessKey,
            getMerchantInfoRequest,
            setEntityDataRequest,
            setEntityDataSuccess,
            fetchMerchantLegalEntityDetailsRequest,
            clearMerchantLegalEntityDetails,
            change,
        },
        dispatch,
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'add-merchant-form',
            enableReinitialize: true,
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(MerchantTab)
);
